import { cn } from '@/shadcn-ui/utils';
import { colors } from '@/theme/colors';
import { SvgIconCommonProps } from './types/svg-icon-common-props';

export default function Check({
  className,
  fillPrimary = colors.neutral10,
}: SvgIconCommonProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('h-[17px] w-[17px]', className)}
    >
      <path
        fill={fillPrimary}
        d="M19.4471 5.57964C19.727 5.2743 20.2015 5.25367 20.5068 5.53356C20.7844 5.78801 20.8267 6.20323 20.6218 6.50603L20.5529 6.59322L9.55287 18.5932C9.29875 18.8704 8.88419 18.913 8.58142 18.7089L8.49422 18.6402L3.49422 14.0735C3.18837 13.7942 3.16688 13.3198 3.44622 13.014C3.70017 12.7359 4.11531 12.6929 4.41848 12.8972L4.50579 12.966L8.953 17.0274L19.4471 5.57964Z"
      ></path>
    </svg>
  );
}
